import { createAtom } from '~utils/atoms';
var wagerAtoms = {
    wagerElement: createAtom(null),
    isCombinationDDLOpen: createAtom(false),
};
export { wagerAtoms };
